import React, { useContext, useMemo } from "react";
import { PickupLocationContext } from "./dashboard/store/PickupLocationContext";

type CsaPickupDayFormElementProps = {
  onDaySelected: (pickupDay: string) => void;
  selectedDay: string;
  selectedLocation: string;
};

const CsaPickupDayFormElement = ({
  onDaySelected,
  selectedDay,
  selectedLocation,
}: CsaPickupDayFormElementProps) => {
  const { pickupLocations } = useContext(PickupLocationContext);
  const pickupDayOptions = useMemo(() => {
    const chosenLocation = pickupLocations.find((loc) => {
      return loc._id === selectedLocation;
    });

    const pickupDays = chosenLocation?.days.map((day) => {
      return (
        <li
          onClick={() => onDaySelected(day.day)}
          key={day.day}
          className={
            selectedDay === day.day
              ? "capitalized info-card info-card-clickable csa-selection-day-options csa-selected"
              : "capitalized info-card info-card-clickable csa-selection-day-options"
          }
        >
          {day.day}s {day.startTime} - {day.endTime}
        </li>
      );
    });
    return <ul className="csa-selected-day-optiones-list"> {pickupDays}</ul>;
  }, [pickupLocations, selectedLocation, selectedDay, onDaySelected]);
  return <>{pickupDayOptions}</>;
};

export default CsaPickupDayFormElement;
